import React from 'react'
import Modalizer from 'components/modalizer/modalizer'
import AddToFolder from 'components/add_to_folder/add_to_folder'

const AddToFolderModal = props => (<Modalizer modalName={props.modalName} width='552px' height='523px' closeAction={() => props.closeModal(props.modalName)}>
	<AddToFolder
		saveLesson={props.saveLesson}
		cancel={props.cancel}
		folders={props.folders}
		modalTitle={props.modalTitle}
		createNewText={props.createNewText}
		createNewFolder={props.createNewFolder} />
</Modalizer>)

export default AddToFolderModal
